const TABLE_COLUMNS = {
  userlist: [
    {
      label: 'Action',
      dataType: "OPTIONS",
      key: 'options',
      hasSort: false,
      templateName: 'action',
      hasMultiColumnFilter: false,
    },
    {
      label: 'Email',
      dataType: "TEXT",
      key: 'email',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '75px'
        }
      }
    },
    {
      label: 'Name',
      dataType: "TEXT",
      key: 'name',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '70px'
        }
      }
    },
    {
      label: 'Roles',
      dataType: "TEXT",
      key: 'roleName',
      hasSort: true,
      hasMultiFilter: true,
      templateName: 'roleNames',
      styles: {
        header: {
          width: '70px'
        }
      }
    },
    {
      label: 'Applications',
      dataType: "TEXT",
      key: 'applicationName',
      templateName: 'applicationNames',
      hasSort: true,
      hasMultiFilter: true,
      // templateName: 'status',
      styles: {
        header: {
          width: '115px'
        }
      }
    },
    {
      label: 'Last Login',
      dataType: "TEXT",
      key: 'lastLoginTime',
      hasSort: true,
      hasMultiFilter: true,
      isDateTypeColumn: true,
      styles: {
        header: {
          width: '95px'
        }
      }
    },
    {
      label: 'Status',
      dataType: "TEXT",
      key: 'status',
      hasSort: true,
      hasMultiFilter: true,
      templateName: 'status',
      styles: {
        header: {
          width: '95px'
        }
      }      
    }
  ],

  usercustomerlist: [
    {
      label: 'Action',
      dataType: "OPTIONS",
      key: 'options',
      templateName: 'action',
      hasSort: false,
      hasMultiColumnFilter: false,
      styles: {
        header: {
          width: '50px',
          marginBottom: '20px'
        }
      },
    },
    {
      label: 'Email',
      dataType: "TEXT",
      key: 'email',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '75px'
        }
      }
    },
    {
      label: 'Name',
      dataType: "TEXT",
      key: 'name',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '70px'
        }
      }
    },
    {
      label: 'Roles',
      dataType: "TEXT",
      key: 'roleName',
      templateName: 'roleNames',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '70px'
        }
      }
    },
    {
      label: 'Applications',
      dataType: "TEXT",
      key: 'applicationName',
      templateName: 'applicationNames',
      hasSort: true,
      hasMultiFilter: true,
      // templateName: 'status',
      styles: {
        header: {
          width: '115px'
        }
      }
    },
    {
      label: 'Last Login',
      dataType: "TEXT",
      key: 'lastLoginTime',
      hasSort: true,
      hasMultiFilter: true,
      isDateTypeColumn: true,
      styles: {
        header: {
          width: '95px'
        }
      }
    },
    {
      label: 'Status',
      dataType: "TEXT",
      key: 'status',
      hasSort: true,
      hasMultiFilter: true,
      templateName: 'status',
      styles: {
        header: {
          width: '95px'
        }
      }
    }
  ],

  rolelist : [
    {
      label: 'Role Name',
      dataType: "TEXT",
      key: 'rolename',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Role Description',
      dataType: "TEXT",
      key: 'roledesc',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Status',
      dataType: "TEXT",
      key: 'status',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Action',
      dataType: "OPTIONS",
      key: 'options',
      hasSort: false,
      templateName: 'action',
      hasMultiColumnFilter: false,
      // styles: {
      //   header: {
      //     width: '50px',
      //     marginBottom: '20px'
      //   }
      // },
    }
  ],
  
  profilelistcustomer : [
    {
      label: 'Action',
      dataType: "OPTIONS",
      key: 'options',
      templateName: 'action',
      hasSort: false,
      hasMultiColumnFilter: false,
      // styles: {
      //   header: {
      //     width: '50px',
      //     marginBottom: '20px'
      //   }
      // },
    },
    {
      label: 'Role Name',
      dataType: "TEXT",
      key: 'roleName',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Application Name',
      dataType: "TEXT",
      key: 'applicationName',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    // {
    //   label: 'Description',
    //   dataType: "TEXT",
    //   jsonKey: {
      //   },
      //     key: 'description'
    //    hasSort: false,
      // hasMultiFilter: true,
    //   styles: {
    //     header: {
    //       width: '190px'
    //     }
    //   }
    // },
    {
      label: 'Status',
      dataType: "TEXT",
      key: 'status',
      hasSort: true,
      hasMultiFilter: true,
      templateName: 'status',
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Date Added',
      dataType: "TEXT",
      key: 'addedDate',
      hasSort: true,
      hasMultiFilter: true,
      isDateTypeColumn: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: '# of URL',
      dataType: "NUMBER",
      key: 'resourceCount.URLs',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of Dashboard',
      dataType: "NUMBER",
      key: 'resourceCount.Dashboards',
       hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of Widget',
      dataType: "NUMBER",
      key: 'resourceCount.Widgets',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of API',
      dataType: "NUMBER",
      key: 'resourceCount.APIs',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of Others',
      dataType: "NUMBER",
      key: 'resourceCount.Others',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    }
  ],

  profilelist : [
    {
      label: 'Action',
      dataType: "OPTIONS",
      key: 'options',
      templateName: 'action',
      hasSort: false,
      hasMultiColumnFilter: false,
      // styles: {
      //   header: {
      //     width: '50px',
      //     marginBottom: '20px'
      //   }
      // },
    },
    {
      label: 'Role Name',
      dataType: "TEXT",
      key: 'roleName',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Application Name',
      dataType: "TEXT",
      key: 'applicationName',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Description',
      dataType: "TEXT",
      key: 'description',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Status',
      dataType: "TEXT",
      key: 'status',
      hasSort: true,
      hasMultiFilter: true,
      templateName: 'status',
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Date Added',
      dataType: "TEXT",
      key: 'addedDate',
      hasSort: true,
      hasMultiFilter: true,
      isDateTypeColumn: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: '# of URL',
      dataType: "NUMBER",
      key: 'resourceCount.URLs',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of Dashboard',
      dataType: "NUMBER",
      key: 'resourceCount.Dashboards',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of Widget',
      dataType: "NUMBER",
      key: 'resourceCount.Widgets',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of API',
      dataType: "NUMBER",
      key: 'resourceCount.APIs',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of Others',
      dataType: "NUMBER",
      key: 'resourceCount.Others',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    }
  ],

  adminlist : [
    {
      label: 'Administrator Name',
      dataType: "TEXT",
      key: 'administratorName',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Administrator Description',
      dataType: "TEXT",
      key: 'administratorDesc',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Status',
      dataType: "TEXT",
      key: 'status',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '190px'
        }
      }
    },
    {
      label: 'Action',
      dataType: "OPTIONS",
      key: 'options',
      hasSort: false,
      hasMultiColumnFilter: false,
    }
  ],
  
  customerlist : [
    {
      label: 'Action',
      dataType: "OPTIONS_INACTIVE",
      key: 'options',
      hasSort: false,
      hasMultiFilter: false,
      templateName : 'action'
    },
    {
      label: 'Organization Name',
      dataType: "TEXT",
      key: 'customerName',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '150px'
        }
      }
    },
    {
      label: 'Organization Admin',
      dataType: "TEXT",
      key: 'customerAdminName',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '150px'
        }
      }
    },
    {
      label: 'Email',
      dataType: "TEXT",
      key: 'email',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '150px'
        }
      }
    },
    {
      label: 'Date Added',
      dataType: "TEXT",
      key: 'addedDate',
      hasSort: true,
      hasMultiFilter: true,
      isDateTypeColumn: true,
      styles: {
        header: {
          width: '150px'
        }
      }
    },
    {
      label: '# of URL',
      dataType: "NUMBER",
      key: 'resourceCount.URLs',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of Dashboard',
      dataType: "NUMBER",
      key: 'resourceCount.Dashboards',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of Widget',
      dataType: "NUMBER",
      key: 'resourceCount.Widgets',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of API',
      dataType: "NUMBER",
      key: 'resourceCount.APIs',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    }
  ],

  customerInAcivelist : [
    {
      label: 'Action',
      dataType: "OPTIONS_INACTIVE",
      key: 'options',
      hasSort: false,
      hasMultiFilter: false,
      templateName : 'action'
    },
    {
      label: 'Organization Name',
      dataType: "TEXT",
      key: 'customerName',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '150px'
        }
      }
    },
    {
      label: 'Organization Admin',
      dataType: "TEXT",
      key: 'customerAdminName',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '150px'
        }
      }
    },
    {
      label: 'Email',
      dataType: "TEXT",
      key: 'email',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '150px'
        }
      }
    },
    {
      label: 'Date Added',
      dataType: "TEXT",
      key: 'addedDate',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '150px'
        }
      }
    },
    {
      label: '# of URL',
      dataType: "NUMBER",
      key: 'resourceCount.URLs',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of Dashboard',
      dataType: "NUMBER",
      key: 'resourceCount.Dashboards',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of Widget',
      dataType: "NUMBER",
      key: 'resourceCount.Widgets',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    },
    {
      label: '# of API',
      dataType: "NUMBER",
      key: 'resourceCount.APIs',
      hasSort: true,
      hasMultiFilter: true,
      styles: {
        header: {
          width: '120px'
        }
      }
    }
  ],

  applicationlist : [
    {
      label: 'Application Name',
      dataType: "TEXT",
      key: 'applicationName',
      hasSort: true,
      hasMultiFilter: true,
    },
    {
      label: 'Description',
      dataType: "TEXT",
      key: 'description',
       hasSort: true,
      hasMultiFilter: true,
    },
    {
      label: 'Application URL',
      dataType: "TEXT",
      key: 'url',
       hasSort: true,
      hasMultiFilter: true,
    },
    {
      label: 'Application Scope EndPoint',
      dataType: "TEXT",
      key: 'scopeEndPoint',
      hasSort: true,
      hasMultiFilter: true,
    }
    // {
    //   label: 'Action',
    //   dataType: "OPTIONS",
    //   templateName: 'action',
    //   key: 'options'
    //   hasMultiColumnFilter: false,
    //   styles: {
    //     header: {
    //       marginBottom: '20px'
    //     }
    //   },
    // }
  ],

  resourcelist : [
    {
      label: 'Resource Name',
      dataType: "TEXT",
      key: 'resourceName',
       hasSort: true,
      hasMultiFilter: true,
    },
    {
      label: 'Description',
      dataType: "TEXT",
      key: 'description',
      hasSort: true,
      hasMultiFilter: true,
    },
    {
      label: 'Resource Type',
      dataType: "TEXT",
      key: 'resourceTypeName',
      hasSort: true,
      hasMultiFilter: true,
    },
    {
      label: 'Application',
      dataType: "TEXT",
      key: "applicationName",
      hasSort: false,
      hasMultiFilter: true
    },
    {
      label: 'Status',
      dataType: "TEXT",
      key: 'status',
      hasSort: true,
      hasMultiFilter: true,
      templateName: 'status',
    }
    // {
    //   label: 'Action',
    //   dataType: "OPTIONS",
    //   key: 'options'
    //   templateName: 'action,
    //   hasMultiColumnFilter: false,
    //   styles: {
    //     header: {
    //       marginBottom: '20px'
    //     }
    //   },
    // }
    
  ],

  actionlist : [
    {
      label: 'Action Name',
      dataType: "TEXT",
      key: 'action',
      hasSort: true,
      hasMultiFilter: true,
    },
    {
      label: 'Description',
      dataType: "TEXT",
      key: 'desc',
      hasSort: true,
      hasMultiFilter: true,
    },
    {
      label: 'Status',
      dataType: "TEXT",
      key: 'status',
      hasSort: true,
      hasMultiFilter: true,
      templateName: 'status',
    }
    // {
    //   label: 'Action',
    //   dataType: "OPTIONS",
    //   key: 'options'
    //   templateName: 'action',
    //   hasMultiColumnFilter: false,
    //   styles: {
    //     header: {
    //       marginBottom: '20px'
    //     }
    //   },
    // }

  ],
  
}


const TABLE_CONFIG  = {
  tableInfo: {
    type: 'dataTable'
  },
  searchFilter: false,
  hasInfiniteScroll: true,
  paginatorOptions: {
    visible: true,
    limit: 25,
    dropdownOptions: [25, 50, 100].map(n => ({ display: n, value: n }))
  },
  tableHeaderFixerInfo: {
    headerFix: true,
    colFix: false,
    height: '500px',
  },
  indexCons: {
    show: false
  }
}

const ES_OPTIONS = {
  READ: 'Read',
  READ_SELF: 'Read_Self',
  EDIT: 'Edit',
};

const resourcesList = {
  user : 'USER',
  profile: 'ROLE',
  resource: 'RESOURCE',
  application: 'APPLICATION',
  actions: 'ACTIONS',
  customers: 'CUSTOMER' 
}

const PREVIOUS_ORDER_OPTIONS = {
  VIEW: 'View Order',
  REPLICATE: 'Duplicate Order',
  COMPARE: 'Compare Order'
}

const CLICKABLE_DATA_TYPE = ['CHECKBOX', 'OPTIONS', 'POPUP', 'WATCHLIST'];


const USER_LIST = [
  { id: '1', label: 'John D' },
  { id: '2', label: 'Dana J' },
  { id: '3', label: 'Lily C' },
  { id: '4', label: 'Rose B' },
  { id: '5', label: 'Jane K' },
];


export const UM_TABLE_CNST = {
  TABLE_COLUMNS,
  ES_OPTIONS,
  PREVIOUS_ORDER_OPTIONS,
  USER_LIST,
  CLICKABLE_DATA_TYPE,
  TABLE_CONFIG,
  RESOURCES_LIST : resourcesList
}
